import React from 'react'
import logo from "../../assets/icons/mocionLogo.svg";
import { useDispatch } from 'react-redux';
import { closeGeneralModelInfo, resetGeneralModelInfo } from '../../lib/redux/slices/controlSlice';
type Props = {
    information:{

            gender:string,
            match_gender:string,
            level:number,
            match_level:number
    },
    type:string
}
 const genderWarningMassage = (gender:string,match_gender:string) => {
       return `This is a only ${match_gender} match are you sure you want to add a ${gender} player?`

    }
    const levelWarningMassage = (level:number,match_level:number) => {
        return `Player level is ${level} but this match level is ${match_level} are you sure you want to add this player?`
    }
    const allTypeWarningMassage = () => {
        return <div><p>The gender and level are out of the match scope.</p>
        <p> Would you like to proceed?</p></div>
    }
function TypeWarningModal({information,type}: Props) {
    console.log(information);
    const dispatch = useDispatch();
    const {gender,match_gender,level,match_level} = information
  return (
     <div className="flex flex-col gap-4 px-6 py-5 text-primary dark:text-white">
      <div className="flex flex-col justify-center items-center gap-4 text-center ">
        <img
          loading="lazy"
          width={200}
          height={200}
          src={logo}
          alt="mocion-logo"
          className="pb-4"
        />
        <h2 className="text-primary dark:text-white">Warning</h2>       
        <p
          className="text-primary dark:text-white font-bold cursor-pointer text-center -mt-2 pb-2"     
        >
         {
            type === 'warning_gender'?genderWarningMassage(gender,match_gender):
            type === 'warning_level'?levelWarningMassage(level,match_level):
            type === 'All_type_warning'?allTypeWarningMassage():""
         }
        </p>
        <button
          className="border-primary bg-primary text-white border rounded-full w-full p-2 font-bold text-xl py-4"
          onClick={()=>{
            dispatch(closeGeneralModelInfo())
          }}
        >
          yes
        </button>
         <button
          className="border-primary border rounded-full w-full p-2 font-bold text-xl py-4"
          onClick={()=>{
            dispatch(resetGeneralModelInfo())
          }}
        >
          No
        </button>
      </div>
    </div>
  )
}

export default TypeWarningModal